import { useLocation } from 'react-router-dom';
import { Button, Alert, Container, SpaceBetween } from '@amzn/awsui-components-react/polaris';
import { useSelector } from 'react-redux';

const StartPage = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const showErrorAlert = queryParams.get('showErrorAlert');
    const errorAlert = queryParams.get('errorAlert');
    const userData = useSelector((state: any) => state.userData);

    const getWelcomeMessage = () => {
        if (userData.userInfo && userData.userInfo.given_name) {
            return `Welcome, ${userData.userInfo.given_name}`;
        }
        return 'Welcome';
    };

    return (
        <Container>
            <div
                style={{
                    fontWeight: 'bold',
                    fontSize: '2em',
                    marginBottom: '20px',
                }}
            >
                {getWelcomeMessage()}
            </div>

            <SpaceBetween direction="vertical" size="l">
                <Alert type="info" header="Choose Your Installation Type">
                    <ul style={{ margin: 0, paddingLeft: '20px' }}>
                        <li style={{ marginBottom: '8px' }}>
                            <strong>Installing or repairing a Fleet Edge device:</strong> Select "Start Installation or
                            Repair" to set up a new Fleet Edge device or troubleshoot an existing one.
                        </li>
                        <li>
                            <strong>Installing a component on an existing Fleet Edge device:</strong> Select "Install
                            Component on Device" to add new components such as Emerald to the existing Fleet Edge
                            installation.
                        </li>
                    </ul>
                </Alert>

                <SpaceBetween direction="vertical" size="m">
                    <Button variant="primary" href={`/vinInformation`}>
                        Start Installation or Repair
                    </Button>
                    <Button variant="normal" href={`/vinInformation?flow=componentInstallation`}>
                        Install Component on Device
                    </Button>
                </SpaceBetween>

                {showErrorAlert === 'true' && (
                    <Alert type="error" dismissible={false}>
                        {errorAlert}
                    </Alert>
                )}
            </SpaceBetween>
        </Container>
    );
};

export default StartPage;
